import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgxsModule } from '@ngxs/store';
import { LocalizedDatePipe } from '../core/locale/localized-date.pipe';
import { MaterialModule } from '../shared/material.module';
import { CartComponent } from './cart/cart.component';
import { CartState } from './cart/state/cart.state';
import { CheckoutComponent } from './checkout/checkout.component';
import { PaymentErrorDialog } from './dialog/payment-error/payment-error-dialog';
import { PaymentComponent } from './payment/payment.component';
import { ReceiptComponent } from './receipt/receipt.component';
import { ReceiptState } from './receipt/state';
import { ShoppingCartRoutingModule } from './shopping-cart-routing.module';

@NgModule({
  declarations: [
    PaymentComponent,
    CartComponent,
    CheckoutComponent,
    ReceiptComponent,
    PaymentErrorDialog,
  ],
  imports: [
    CommonModule,
    ShoppingCartRoutingModule,
    MaterialModule,
    TranslateModule.forChild(),
    NgxsModule.forFeature([ CartState, ReceiptState]),
  ],
  providers: [
    LocalizedDatePipe,
  ],
  exports: [
    CheckoutComponent,
    PaymentComponent
  ],
})
export class ShoppingCartModule { }
